import ApiRequest from '../request'

export default class Tickets {
  constructor() {
    this.apiRequest = new ApiRequest()
  }

  async getDetailExtTicket(ticket_token, params) {
    try {
      // fetch detail ticket by ticket_token
      const res = await this.apiRequest.get(
        `ext_tickets/${ticket_token}`,
        params
      )
      return res
    } catch (error) {
      return error.response
    }
  }
  async getMecTickets(params) {
    let Queryparams = {
      filter: JSON.stringify({ ...params.filter, process_id: 13 }),
      sort: JSON.stringify(params.sort),
    }
    try {
      const res = await this.apiRequest.get(`ext_mec_tickets`, Queryparams)
      return res
    } catch (error) {
      return error.response
    }
  }
  async getExtCoprosTickets() {
    try {
      const res = await this.apiRequest.get(`ext_copro_tickets`)
      return res
    } catch (error) {
      return error.response
    }
  }
  async updateExtranetTicket(ticket_token, payload) {
    try {
      // update ticket
      const res = await this.apiRequest.put(
        `ext_tickets/${ticket_token}`,
        payload
      )
      return res
    } catch (error) {
      return error.response
    }
  }
  async getFilesExtranetTicket(id, params) {
    try {
      const res = await this.apiRequest.get(`ext_tickets/${id}/files`, params)
      return res
    } catch (error) {
      return error.response
    }
  }
}
